import * as cryptoJS from "crypto-js";

class StringUtil {

    static clear(str: string): string {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
    }

    static truncate(str: string, length: number) {
        const truncated: string = str?.substring(0, length) || "";
        return `${truncated}${str?.length > truncated?.length ? "..." : ""}`;

    }

    static encode(subject: any): string {
        const str: string = JSON.stringify(subject)
        return cryptoJS.AES.encrypt(str, `${process.env.REACT_APP_CIPHER}`).toString()
    }

    static decode<T = any>(hash: string): T {
        return JSON.parse(cryptoJS.AES.decrypt(hash, `${process.env.REACT_APP_CIPHER}`).toString(cryptoJS.enc.Utf8));
    }

    static trim(str: string): string {
        return str?.replace(/\s{2,}/g, ' ')?.trim();
    }

    static validaTipoDocumento(documento: string): string {
    
        documento = documento.replaceAll(".", "");
        documento = documento.replaceAll("/", "");
        documento = documento.replaceAll("-", "");
        
        switch(documento.length){
            case 11:
                return "CPF"
            case 14:
                return "CNPJ"
            default:
                return "INVALIDO"
        }
    }

    static retornaTextoInformativo(textosInformativos: any[], formaPagamentoId: number): string {
        const textoAux = textosInformativos.find((t: any) => t.id === formaPagamentoId);

        if(textoAux){
            return textoAux.texto_informativo;
        }

        return "";
    }
}


export { StringUtil }